import { Stack, Typography, useTheme } from "@mui/material";
import { SparkLine } from "src/components";
import { useBreakpoints } from "src/hooks";

interface IProps {
  isLoading: boolean;
  data: { dateUtc: string; value: number | null }[] | undefined;
  minYValue?: number;
  maxYValue?: number;
  formatValue?: (value: number) => string;
}

const StatisticWithGraph = (props: IProps) => {
  const theme = useTheme();
  const { isMdUp } = useBreakpoints();

  const mostRecentCoherenceScore = props.data ? props.data[props.data.length - 1] : undefined;

  return (
    <Stack direction="row" spacing={0.5} sx={{ alignItems: "baseline", width: "100%" }}>
      <Typography
        variant={isMdUp ? "h1" : "h3"}
        sx={{ color: props.isLoading ? theme.palette.grey[200] : undefined, minWidth: isMdUp ? 95 : 50 }}
      >
        {mostRecentCoherenceScore?.value
          ? props.formatValue
            ? props.formatValue(mostRecentCoherenceScore.value)
            : mostRecentCoherenceScore!.value
          : "-"}
      </Typography>
      <SparkLine
        data={
          props.data
            ? props.data.map((x) => {
                return { x: x.dateUtc, y: x.value ?? null };
              })
            : []
        }
        isLoading={props.isLoading}
        minYValue={props.minYValue}
        maxYValue={props.maxYValue}
        sx={{
          flex: 1,
          width: 60,
          height: 30,
          borderLeft: `1px solid ${theme.palette.grey[200]}`,
          borderBottom: `1px solid ${theme.palette.grey[200]}`,
          borderBottomLeftRadius: "4px",
        }}
      />
    </Stack>
  );
};

export { StatisticWithGraph };
